export default "__VITE_ASSET__DvTv0Hb$__"